import { getCiudades, getComunaPorId, getListaParticipantes, getParticipante, getValoresDominio, obtenerMutuoComple } from "../services/servicesParticipantes";
import { useRef, useState } from "react";
import {
    ciudades, ciudadesSelect, comunas, comunasSelect, estadoCivilSelect, Participante,
    ParticipanteForm, ParticipanteRequest, TiposDeudaCodeudorSelect,
    TiposBeneficiarioSiiSelect,
    SeguroParticipanteDto,
    CalcularMontosDto,
    RespuestaCalculoMontoDto,
    RespuestaMutuoComple
} from "../models/participantes";
import { Dominios, enumTipoParticipanteConValores, enumTipoPersona, StatusCode } from "../../../utils/enums";
import { selectorTransversal } from "../../../dtos/selector";
import { UseFormSetValue } from "react-hook-form";
import { calculoMontoSeguro, getCoberturasPolizas, getCodigosPoliza, GetCodPolizasHijo, getSegurosPorPoliza } from "../services/servicesSeguros";
import { CoberturaPoliza } from "../models/seguroDeudor";
import { AxiosResponse } from "axios";
import { getDeudor, getDeudorJuridico } from "../services/servicesDeudores";
import { getCodeudor } from "../services/servicesCodeudor";
import { getMandatario } from "../services/servicesMandatarios";
import { getConyuge } from "../services/servicesConyuge";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

export function useParticipantes() {
    const formRef = useRef<HTMLFormElement>(null);
    const [listaParticipantes, setListaPartcipantes] = useState<Participante[]>([]);
    const [coberturaPoliza, setCoberturaPoliza] = useState<CoberturaPoliza[]>([]);
    const [ciudadesSelect, setCiudadesSelect] = useState<ciudadesSelect[]>([]);
    const [comunasSelect, setComunasSelect] = useState<comunasSelect[]>([]);
    const [comunasCorrespondecia, setComunasCorrespondecia] = useState<comunasSelect[]>([]);
    const [estadoCivilSelect, setEstadoCivilSelect] = useState<estadoCivilSelect[]>([]);
    const [tiposDeudaCodeudorSelect, setTiposDeudaCodeudorSelect] = useState<TiposDeudaCodeudorSelect[]>([]);
    const [beneficioSiiSelect, setBeneficioSiiSelect] = useState<TiposDeudaCodeudorSelect[]>([]);
    const [tiposBeneficiariosSiiSelect, setTiposBeneficiariosSiiSelect] = useState<TiposBeneficiarioSiiSelect[]>([]);
    const [seguroParticipante, setSeguroParticipante] = useState<SeguroParticipanteDto>();
    const [polizas, setPolizas] = useState<selectorTransversal[]>([]);
    const [polizasHijo, setPolizasHijo] = useState<selectorTransversal[]>([]);
    const [mutuoComple, setMutuoComple] = useState<RespuestaMutuoComple>();
    const [defaultValues, setDefaultValues] = useState<ParticipanteForm>({
        tipoPersona: enumTipoPersona.Natural,
        direccionParticular: '',
        rolParticipante: enumTipoParticipanteConValores.Deudor,
        glosaTipoParticipante: undefined,
        glosaTipoPersona: undefined,
        rut: '',
        esConyuge: false,
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombres: '',
        fechaNacimiento: null,
        direccion: '',
        ciudadId: '',
        nombreCiudad: undefined,
        comunaId: '',
        nombreComuna: undefined,
        porcentajeDivRenta: 0,
        profesionActividad: '',
        sexo: '',
        estadoCivilId: 0,
        glosaEstadoCivil: '',
        nacionalidad: '',
        telefonoParticular: '',
        telefonoCelular: '',
        telefonoOficina: '',
        email: '',
        direccionCorrespondencia: '',
        ciudadCorrespondenciaId: '',
        nombreCiudadCorrespondencia: undefined,
        comunaCorrespondenciaId: '',
        nombreComunaCorrespondencia: undefined,
        deudaCodeudorEnCalidadDe: '',
        porcentajeDeudaDirecta: 0,
        porcentajeDeudaSeguro: 0,
        porcentajeDominio: undefined,
        tieneBeneficioTributario: false,
        beneficioSiiAsignado: undefined,
        beneficiarioSiiEnCalidadDe: undefined,
        rolPropiedadBeneficioSii: undefined,
        existeCodeudorBeneficiarioSii: false,
        deudorEsBeneficiarioSii: false,
        codigoPoliza: '',
        codigoInterno: '',
        tasa: 0,
        montoPrimaAnual: 0,
        montoAsegurado: 0,
        mesesGratuidad: 0,
        nombreCompania: null,
        cantidadCuotasAnuales: 0,
        montoPrimaDividendo: 0,
        tasaSobrePrima: 0,
        deudaDirecta: null,
        deudaSeguro: null,
        tienePrima: null
    });

    const scrollToForm = () => {
        if (formRef.current) {
            const { top } = formRef.current.getBoundingClientRect();
            window.scrollTo({
                top: window.scrollY + top - 80,
                behavior: 'smooth',
            });
        }
    };

    const listaParticipantePorId = async (id: number) => {

        const response: AxiosResponse<ListResponseDto<Participante>> = await getListaParticipantes(id)
        if (response.status !== StatusCode.Ok) return;

        const participantes: Participante[] = await response.data.items;

        setListaPartcipantes(participantes);
        return participantes;

    }

    const participantePorTipo = async (data: ParticipanteRequest) => {
        const resp = await getParticipante(data)
        if (resp && resp.status === 200) {
            const data: ParticipanteForm = await resp.data;
            setDefaultValues(data);
        }

        return;
    }

    const buscarParticipante = async (data: ParticipanteRequest) => {
        let response : AxiosResponse | null = null;
        if (data.codigoTipoParticipante === 0){
            response = await getDeudor(data);
        }
        else if (data.codigoTipoParticipante === 1){
            response = await getCodeudor(data);
        }
        else if (data.codigoTipoParticipante === 2){
            response = await getMandatario(data);
        }
        else if (data.codigoTipoParticipante === 3){
            response = await getConyuge(data);
        }
        else if (data.codigoTipoParticipante === 4){
            response = await getDeudorJuridico(data);
        }
        return response;
    }

    const getParticipantes = async (idMutuo: number) => {
        await listaParticipantePorId(idMutuo);
    }

    const ciudades = async () => {
        const resp: AxiosResponse<ListResponseDto<ciudades>> = await getCiudades()
        if (resp && resp.status === 200) {
            const data: ciudades[] = await resp.data.items;
            let ciudades: ciudadesSelect[] = [];
            data.map((x) => ciudades.push({ value: (x.codigo), label: x.nombre }));
            setCiudadesSelect(ciudades);
        }

        return;
    }

    const comunaPorId = async (idCiudad: string, esCorrespondencia: boolean = false) => {
        const resp: AxiosResponse<ListResponseDto<comunas>> | undefined = await getComunaPorId(idCiudad)
        if (resp && resp.status === 200) {
            const data: comunas[] = await resp.data.items;
            let comunas: comunasSelect[] = [];
            data.map((x) => comunas.push({ value: (x.codigo), label: x.nombre }));

            if (!esCorrespondencia) {
                setComunasSelect(comunas);
            }
            else {
                setComunasCorrespondecia(comunas);
            }
        }

        return;
    }

    const listaEstadoCivil = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.ESTADO_CIVIL)
        if (resp && resp.status === 200) {
            const data: selectorTransversal[] = await resp.data.items;
            setEstadoCivilSelect(data);
        }

        return;
    }

    const tiposDeudaCodeudor = async () => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_DEUDA)

        if (resp && resp.status === 200) {

            const data: selectorTransversal[] = await resp.data.items;
            setTiposDeudaCodeudorSelect(data);
        }

        return;
    }

    const beneficiosSii = async () => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.BENEFICIOS_SII)

        if (resp && resp.status === 200) {

            const data: selectorTransversal[] = await resp.data.items;

            setBeneficioSiiSelect(data);
        }

        return;
    }

    const tiposBeneficiariosSii = async () => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_BENEFICIARIO)

        if (resp && resp.status === 200) {

            const data: selectorTransversal[] = await resp.data.items;

            setTiposBeneficiariosSiiSelect(data);
        }

        return;
    }

    const getSeguroParticipante = async (codigoPoliza: string, codigoHijo: string) => {

        const resp = await getSegurosPorPoliza(codigoPoliza, codigoHijo);
        if (resp && resp.status === 200) {
            const data: SeguroParticipanteDto = await resp.data;
            return data;
        }

        return null;
    }

    const getPolizas = async (tipoSeguro: string) => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getCodigosPoliza(tipoSeguro);
        if (resp && resp.status === 200) {
            const data: selectorTransversal[] = await resp.data.items;
            setPolizas(data);
        }

        return;
    }

    const getPolizasInterna = async (codigoPoliza: string, tipoSeguro: string) => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await GetCodPolizasHijo(codigoPoliza, tipoSeguro);
        if (resp && resp.status === 200) {
            const data: selectorTransversal[] = await resp.data.items;
            setPolizasHijo(data);
        }

        return;
    }

    const calcularMonto = async (dataRequest: CalcularMontosDto) => {

        const resp = await calculoMontoSeguro(dataRequest);
        if (resp && resp.status === 200) {
            const data: RespuestaCalculoMontoDto = await resp.data;

            return data;
        }

        return null;
    }

    const obtenerCoberturas = async (codigo: string, codigoInterno: string) => {

        const resp: AxiosResponse<ListResponseDto<CoberturaPoliza>> = await getCoberturasPolizas(codigo, codigoInterno);
        if (resp && resp.status === 200) {
            const data: CoberturaPoliza[] = await resp.data.items;
            setCoberturaPoliza(data);
        }
    }


    const limpiarDatosSeguros = (setValue: UseFormSetValue<ParticipanteForm>, limpiarCodInterno: boolean = true, esCodeudor = false) => {

        if (limpiarCodInterno) {
            setValue("codigoInterno", "");
        }

        if (!esCodeudor) {
            setValue("deudaDirecta", 100);
            setValue("deudaSeguro", 100);
        }

        setValue("tasa", 0);
        setValue("montoPrimaAnual", 0);
        setValue("mesesGratuidad", 0);
        setValue("nombreCompania", "");
        setValue("cantidadCuotasAnuales", 0);
        setValue("montoPrimaDividendo", 0);
        setValue("tasaSobrePrima", 0);
    }

    const obtenerMutuoComplementario = async (idSolicitud: number) => {
        const resp = await obtenerMutuoComple(idSolicitud);
        if (resp.status === StatusCode.Ok) {
            setMutuoComple(resp.data);
        }
    }

    return {
        listaParticipantePorId,
        participantePorTipo,
        setDefaultValues,
        getParticipantes,
        scrollToForm,
        ciudades,
        comunaPorId,
        setComunasSelect,
        listaEstadoCivil,
        getSeguroParticipante,
        getPolizas,
        getPolizasInterna,
        limpiarDatosSeguros,
        setPolizasHijo,
        calcularMonto,
        obtenerCoberturas,
        polizasHijo,
        polizas,
        seguroParticipante,
        listaParticipantes,
        defaultValues,
        formRef,
        ciudadesSelect,
        comunasSelect,
        comunasCorrespondecia,
        estadoCivilSelect,
        tiposDeudaCodeudor,
        tiposDeudaCodeudorSelect,
        beneficiosSii,
        beneficioSiiSelect,
        tiposBeneficiariosSii,
        tiposBeneficiariosSiiSelect,
        coberturaPoliza,
        mutuoComple,
        setComunasCorrespondecia,
        obtenerMutuoComplementario,
        buscarParticipante
    }
}

